import { Chart } from '@frontend/chart/types';

/** Duration values are average completed pick-up-pending timer seconds per user. */
export const PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_PICK_UP_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'User Nine', data: [{ label: 'full_period', value: 345600 }] },
        { name: 'User Ten', data: [{ label: 'full_period', value: 216000 }] },
        { name: 'User Eleven', data: [{ label: 'full_period', value: 129600 }] },
        { name: 'User Twelve', data: [{ label: 'full_period', value: 64800 }] },
        { name: 'User Thirteen', data: [{ label: 'full_period', value: 36000 }] },
        { name: 'User Fourteen', data: [{ label: 'full_period', value: 18000 }] },
        { name: 'User Fifteen', data: [{ label: 'full_period', value: 9000 }] },
        { name: 'User Sixteen', data: [{ label: 'full_period', value: 4500 }] }
    ]
};
